module.exports = __webpack_public_path__ + "img/wechat_qrcode_pay.71c98bf2.png";